import type { PlanFeatureLimit } from '../features/auth';
import { isEmptyOrEmptyObject } from './objects';

export const getLimitValue = (feature: PlanFeatureLimit | Record<string, never> | undefined) => {
  // if the feature is an empty object it means there are no limits for this feature
  if (!isEmptyOrEmptyObject(feature)) {
    const featureLimits = feature as PlanFeatureLimit;
    return featureLimits.limit;
  }
  return false;
};
